/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

sortSelectStyles.select = {
    labelProps: {
        size: 13,
        lineHeight: "22px",
        weight: "normal",
        ellipsis: false,
        css: css`
            width: auto;
            padding: 0;
            margin-right: 13px;
            flex: 0 0 auto;

            ${screen("lt", "sm")} {
                width: 55px;
                text-align: left;
            }
        `,
    },
    cssOverrides: {
        formField: css`
            align-items: center;
        `,
        formInputWrapper: css`
            width: 172px;

            ${screen("lte", "sm")} {
                flex: 1;
                width: auto;
            }
        `,
    },
    sizeVariant: "small",
};
